import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'ramda';

import s from './styles.module.scss';

const PageHeader = ({ patientInfo, title }) => (
  <>
    <h1 className={s.pageTitle} data-test="pageTitle">
      {title}
    </h1>
    {patientInfo && (
      <div className={s.patientInfo}>
        {map(
          item => (
            <div key={item}>{item}</div>
          ),
          patientInfo,
        )}
      </div>
    )}
  </>
);

PageHeader.defaultProps = {
  patientInfo: null,
};

PageHeader.propTypes = {
  patientInfo: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default PageHeader;
